import { useKeycloak } from "@react-keycloak/web";
import { AdminAccess, getAdminAccess } from "../utils/adminAccess";

// Admin capabilities of the logged-in user, read from the Keycloak token's
// realm roles. The backend enforces the same roles on every admin endpoint;
// this only decides what the UI shows.
export const useAdminAccess = (): AdminAccess => {
  const { keycloak } = useKeycloak();

  return getAdminAccess(keycloak.tokenParsed);
};
